// extracted by mini-css-extract-plugin
export default {"tile":"PreconfiguredFramesButton__tile--RLye6","image":"PreconfiguredFramesButton__image--BVe6b","label":"PreconfiguredFramesButton__label--ywXR7"};